import type { SimpleStyleT } from "tweenly"
export const renderSimpleStyleValue = (style: SimpleStyleT, type: "css" | "inline") => {
    return style.render(style.value, style.unit, type).value
}

/**
 * Render a single style using its render function with a fallback.
 * The fallback handles objects whose render functions lost closure scope after
 * json-fn deserialization (scene.json files generated before the new Function fix).
 */
const safeRender = (
    style: SimpleStyleT,
    type: "css" | "inline"
): { property: string; value: string | number } => {
    try {
        return style.render(style.value, style.unit, type)
    } catch {
        const cssProp = style.property.replace(/([A-Z])/g, (m) => `-${m.toLowerCase()}`)
        const property = type === "css" ? cssProp : style.property
        const value = style.unit ? `${style.value}${style.unit}` : String(style.value)
        return { property, value }
    }
}

export const renderSimpleStyles = (styles: SimpleStyleT[], type: "css" | "inline") => {
    if (type === "inline") {
        let result = {}
        styles.forEach((style) => {
            const styleRender = safeRender(style, "inline")
            return Object.assign(result, {
                [styleRender.property]: styleRender.value,
            })
        })
        return result
    } else {
        let result: string = styles
            .map((style) => {
                const styleRender = safeRender(style, "css")
                return `${styleRender.property}:${styleRender.value}`
            })
            .join("; ")
        return result
    }
}
